import FileDownloadOutlined from '@mui/icons-material/FileDownloadOutlined';
import Box from '@mui/material/Box';
import { t } from 'i18next';
import { useCallback, useState } from 'react';

import { SmallLoadingButton } from '~components/Order/ordersDispatchStyledComponents';
import { useDriverDays } from '~hooks/useDriverDays/useDriverDays';

import OrderSelectorCTA from '../components/CTAs/OrderSelectorCTA';
import { DriverDayDateFilter } from './DriverDayDateFilter';
import { DriverDayMainFilters } from './DriverDayMainFilters';

export function DriverDayFilters() {
  const { exportDriverDaysCsv } = useDriverDays();
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = useCallback(async () => {
    setIsExporting(true);
    try {
      await exportDriverDaysCsv();
    } finally {
      setIsExporting(false);
    }
  }, [exportDriverDaysCsv]);

  return (
    <Box aria-label="filter area" sx={{ display: 'flex', mb: 3, gap: 2 }}>
      <DriverDayDateFilter />
      <DriverDayMainFilters />
      <Box sx={{ flexGrow: 1 }} />
      <SmallLoadingButton
        aria-label={t('approvals.export.export_csv')}
        loading={isExporting}
        loadingPosition="start"
        onClick={handleExport}
        startIcon={<FileDownloadOutlined />}
        variant="outlined"
        color="secondary"
      >
        {t('approvals.export.export_csv')}
      </SmallLoadingButton>
      <OrderSelectorCTA />
    </Box>
  );
}
